<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import moment from 'moment';
   import jsPDF from "jspdf";
   import autoTable from "jspdf-autotable";

   export default {
      page: {
         title: "Consultations Report",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         const current_date = moment().format("YYYY-MM-DD");
         return {
            title: "Consultations Report",
            items: [
               {
                  text: "Consultations Report",
                  active: true,
               },                   
            ],

            sales: [],            
            
            pagination: {},
            consultations: [],
            doctors: [],
            all_consultations: [],
            doctor_id: "",
            from_date: current_date,
            to_date: current_date,
            keyword: "",
            listing_length: 10,
            status: '',
            type: '',
            token: "",
            errors: {},          
            active_page_url: null,
         };
      },
      mounted() {
         this.clearLocalStorage();

      },

      created() {
         this.fetchDoctors();
         this.fetchConsultations();
      },

      methods: {
         clearLocalStorage() {
            localStorage.removeItem("consultation_filters");
            localStorage.removeItem("cancel_consultation_filters");
            localStorage.removeItem("patient_filters");
            localStorage.removeItem("doctor_filters");

         },
         clearForm() {
               this.errors = {};  
         },
         fetchDoctors() {  
            let url = "api/admin/consultations/getdoctors?keyword=" + '';         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.doctors = responseData.doctors;
               })
               .catch((err) => console.log(err));
         },

         fetchConsultations(page_url = null) {

         this.getToken();
         let url = "api/admin/consultation_report?&limit=" + this.listing_length + "&from_date=" + this.from_date + "&to_date=" + this.to_date + "&keyword=" + this.keyword + "&status=" + this.status + "&type=" + this.type + "&doctor_id=" + this.doctor_id;

         page_url = page_url || url;

         if(localStorage.back_url) {
            page_url = localStorage.back_url;  
            localStorage.removeItem('back_url');
         }    

         this.active_page_url = page_url;
         this.loading = true;

         this.$axios
            .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               console.log(responseData);
               this.consultations = responseData.consultations.data;
               this.all_consultations = responseData.all_consultations;

               this.pagination = responseData.consultations.links;
               this.from = responseData.consultations.from;
               this.to = responseData.consultations.to;
               this.total = responseData.consultations.total;
             this.clearForm();
         })
         .catch((error) => {
               if (error.response) {
                  if (error.response.data.message) {
                     if(typeof error.response.data.message === 'object') {
                        this.errors = error.response.data.message;
                        console.log(error.response.status);
                     } else {
                        this.$swal("", error.response.data.message, "error");
                     }                        
                     
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
         })
         .finally(() => (this.loading = false));
         }, 

         downloadConsultationsPdf() {
            let url = "api/admin/consultation_report_download?limit=" + this.listing_length + "&from_date=" + this.from_date + "&to_date=" + this.to_date + "&keyword=" + this.keyword + "&status=" + this.status + "&type=" + this.type;
            this.getToken();
            this.loading = true;
            this.$axios
               .get(url, {
                     headers: { Authorization: "Bearer " + this.token },
                     responseType: "blob" 
               })
               .then((res) => {
                     const blob = new Blob([res.data], { type: "application/pdf" });
                     const url = window.URL.createObjectURL(blob);
                     const link = document.createElement("a");
                     link.href = url;
                     link.download = "consultation_report.pdf"; 
                     link.click();
                     window.URL.revokeObjectURL(url);
               })
               .catch((error) => {
                  console.error("Error downloading PDF file:", error);
                  const reader = new FileReader();
                  reader.onload = (event) => {
                     const text = event.target.result;
                     const errorData = JSON.parse(text);
                     const errorMessage = errorData.message;
                     if(errorMessage){
                        this.errors = errorMessage;
                     }else{
                     this.$swal("", "Failed to download PDF file", "error");
                     }
                  };
                  reader.readAsText(error.response.data);
               })
         },

         downloadConsultationPdfFromClient() {
            if (!this.all_consultations.length) {
               this.$swal("", "No data available to download", "info");
               return;
            }

            const doc = new jsPDF();
            doc.text("Consultations Report", 14, 15);

            const headers = [
               ["Sl No", "Patient", "Doctor", "Type", "Booking Date & Slot", "Status", "Created On"]
            ];

            const rows = this.all_consultations.map((c) => {
               const sl_no = c.sl_no;
               const patient = c.patient_id === null ? "Guest" : `${c.member_name || c.patient_name}\n${c.country_code || ""} ${c.mobile || ""}\n${c.email || ""}`;
               const doctor = `${c.prefix || ""} ${c.doctor_name}`;
               const type = c.consultation_type === 1 ? "Video" : c.consultation_type === 2 ? "Home" : "Clinic";
               const slot = `${this.$options.filters.formatDate(c.booking_date)}\n${this.$options.filters.formatTime(c.consultation_start)} - ${this.$options.filters.formatTime(c.consultation_end)}`;
               const statusMap = { 1: "Pending", 2: "Completed", 3: "Cancelled", 4: "No Show" };
               const status = statusMap[c.status] || "Unknown";
               const created = this.$options.filters.formatDateTime(c.booking_created_at);

               return [sl_no, patient,doctor, type, slot, status, created];
            });

            autoTable(doc, {
               startY: 20,
               head: headers,
               body: rows,
               styles: { fontSize: 8, cellPadding: 2 },
               headStyles: { fillColor: [41, 128, 185] },
               columnStyles: {
                  0: { cellWidth: 10 }, // Sl No
                  1: { cellWidth: 35 }, // Patient
                  2: { cellWidth: 35 }, // Doctor
                  3: { cellWidth: 15 }, // Type
                  4: { cellWidth: 45 }, // Slot
                  5: { cellWidth: 20 }, // Status
                  6: { cellWidth: 30 }, // Created
               }
            });

            doc.save("Consultations_Report.pdf");
         },

         downloadConsultationsExcel() {
            let url = "api/admin/consultation_excel_download?limit=" + this.listing_length + "&from_date=" + this.from_date + "&to_date=" + this.to_date + "&keyword=" + this.keyword + "&status=" + this.status + "&type=" + this.type;     
            this.getToken();
            this.loading = true;
            this.$axios
               .get(url, {
                     headers: { Authorization: "Bearer " + this.token },
                     responseType: "blob" // Specify blob response type
               })
               .then((res) => {
                     const blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                     const url = window.URL.createObjectURL(blob);
                     const link = document.createElement("a");
                     link.href = url;
                     link.download = "consultation_report.xlsx";
                     link.click();
                     window.URL.revokeObjectURL(url);
               })
               .catch((error) => {
                  console.error("Error downloading PDF file:", error);
                  const reader = new FileReader();
                  reader.onload = (event) => {
                     const text = event.target.result;
                     const errorData = JSON.parse(text);
                     const errorMessage = errorData.message;
                     if(errorMessage){
                        this.errors = errorMessage;
                     }else{
                     this.$swal("", "Failed to download PDF file", "error");
                     }
                  };
                  reader.readAsText(error.response.data);
               })
         },


         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         },  

         
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">

            <div class="card">
               <div class="card-body">
                  <!----- filters area starts---->
                  <div class="row mb-3">
                     <div class="form-group col-lg-3">
                        <label>From Date <span class="text-danger">*</span></label>
                        <!-- <b-form-input type="date" ></b-form-input> -->
                        <input type="date" v-model="from_date" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.from_date) }">
                        <div v-for="(val, index) in errors.from_date" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                        </div>
                     </div>
                     <div class="form-group col-lg-3">
                        <label>To Date <span class="text-danger">*</span></label>
                        <!-- <b-form-input type="date"></b-form-input> -->
                        <input type="date" v-model="to_date" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.to_date) }">
                        <div v-for="(val, index) in errors.to_date" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                        </div>
                     </div>
                     
                     <div class="form-group col-lg-3">
                        <label>Consultations</label>
                       <select class="form-control" v-model="status">
                                 <option value="">All</option>
                                 <!-- <option value="today">Today's Consultations</option> -->
                                 <option value="1">Upcoming Consultations</option>
                                 <option value="2">Completed Consultations</option>
                                 <option value="3">Cancelled Consultations</option>
                              </select>
                     </div>
                     <div class="form-group col-lg-3">
                        <label>Doctor</label>

                       <select class="form-control" v-model="doctor_id" >
                                 <option value="">All Doctors</option>
                                 <option :value="doctor.id" v-for="doctor in doctors" :key="doctor.id">{{doctor.name}}</option>
                              </select>
                     </div>
                     <div class="form-group col-lg-3">
                        <label>Type</label>

                       <select class="form-control" v-model="type" >
                                 <option value="">All</option>
                                 <option value="1">Video</option>
                                 <option value="2">Home</option>
                                 <option value="3">Clinic</option>
                              </select>
                     </div>
                  </div>
                  <!----- filters area ends---->

                  <div class="row">
                     <div class="col-12">
                        <button class="btn btn-primary me-2" type="button" @click="fetchConsultations()">View</button>
                        <button class="btn btn-primary me-2" type="button" @click="downloadConsultationPdfFromClient()">Download PDF</button>
                        <button class="btn btn-primary me-2" type="button" @click="downloadConsultationsExcel()">Download Excel</button>                     </div>
                  </div>
               </div>
            </div>
            <div class="card">
               <div class="card-body">
                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchConsultations()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchConsultations()"/>
                           </label>
                        </div>                     
                        
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                         
                              <tr>
                              <th width="5%">Sl No</th>              
                              <th width="15%">Patient</th>              
                              <th width="15%">Doctor</th>   
                              <th width="5%">Type</th>
                              <th width="20%">Booking Date & Slot</th>
                              <th width="20%">Status</th>  
                              <th width="15%">Created On</th>
                              <th width="20%">Options</th>
                           </tr>
                          
                        </thead>
                        <tbody v-if="Boolean(consultations.length)">
                           <tr v-for="consultation in consultations" :key="consultation.id">
                              <td>{{consultation.sl_no}}</td> 
                             <td> <span v-if="consultation.patient_id">{{consultation.member_name || consultation.patient_name}}<br> {{ consultation.country_code }} {{consultation.mobile}}<br>
                                 {{consultation.email}}<br></span> <span v-else>Guest</span></td>                       
                              
                              <td>{{consultation.prefix}} {{consultation.doctor_name}}</td>
                              <td v-if="consultation.consultation_type === 1">Video</td>      
                              <td v-if="consultation.consultation_type === 2">Home</td>                 
                              <td v-if="consultation.consultation_type === 3">Clinic</td>                            
                              <td>{{consultation.booking_date|formatDate}}<br>{{consultation.consultation_start|formatTime}} - {{consultation.consultation_end|formatTime}}</td>
                              <td v-if="consultation.status === 1">Pending</td>
                              <td v-if="consultation.status === 2">Completed</td>
                              <td v-if="consultation.status === 3">Cancelled</td>
                              <td v-if="consultation.status === 4">No Show</td>
                              <td>{{consultation.booking_created_at|formatDateTime}}</td>
                             
                              <td>
                                 <router-link :to="{ name: 'consultations.details', params:{ id:consultation.id } }"  v-if="consultation.patient_id" class="btn btn-primary me-2 mb-2 btn-sm">Details</router-link>
                              </td>
                           </tr>
                 
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="7" class="text-center">No consultations found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts --->     
                  <caption v-if="Boolean(consultations.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchConsultations(page.url + '&limit='+ listing_length + '&from_date='+ from_date + '&to_date=' + to_date + '&keyword=' + keyword + '&status=' + status + '&type=' + type + '&doctor_id=' + doctor_id)">
                        <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                        <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                        <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->


               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
